import { Autoplay, EffectFade, Navigation, Swiper } from 'swiper'
import 'swiper/swiper-bundle.css'

window.addEventListener('load', function () {
  const kvSlider = new Swiper('.kv_slider', {
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    loop: true,
    effect: 'fade',
    speed: 3000,
    modules: [Autoplay, EffectFade],
  })
  const guideSwiper = new Swiper('.guide_slider', {
    slidesPerView: 1.25,
    spaceBetween: 24,
    loop: true,
    centeredSlides: true,
    speed: 1000,
    modules: [Navigation, Autoplay],
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    breakpoints: {
      769: {
        slidesPerView: 1.25,
        spaceBetween: 80,
        loop: true,
      },
    },
  })
  const images = document.querySelectorAll('.img img')
  const modal = document.getElementById('modal')
  const modalImg = document.getElementById('modalImg')

  images.forEach((img) => {
    img.addEventListener('click', function () {
      modal.style.display = 'flex'
      modalImg.src = this.src
    })
  })

  modal.addEventListener('click', function () {
    modal.style.display = 'none'
  })

  document.addEventListener('scroll', () => {
    const { scrollY } = window

    const item01 = document.querySelector('.item01')
    const item02 = document.querySelector('.item02')
    const item03 = document.querySelector('.item03')
    item01.style.transform = `translateY(-${scrollY * 0.2}px)`
    item02.style.transform = `translateY(-${scrollY * 0.1}px)`
    item03.style.transform = `translateY(-${scrollY * 0.15}px)`
  })
})
